import React from "react";
import { useParams } from "react-router";
import { AutoScrollTopComponent } from "../../components/auto-scroll-top.component";
import { ContactContainerComponent } from "../../contact/contact-container.component";
import { getiService, getService } from "../../data";
import { ServiceCoverComponent } from "../components/service-cover.component";
import { ServiceDetailsCardComponent } from "../components/service-details-card.component";

interface IServicePageProps {}

export const ServicePage: React.FC<IServicePageProps> = (
    props: IServicePageProps
) => {
    const { iserviceid, serviceid } = useParams();

    const iService = getiService(iserviceid || "");
    const service = getService(iserviceid || "", serviceid || "");

    if (!iService || !service) return <></>;

    return (
        <>
            <AutoScrollTopComponent changeDetector={serviceid} />
            <ServiceCoverComponent
                backgroundImage={service.topCoverImage}
                title={service.title}
                urls={[
                    { label: "Services", path: "/home#services" },
                    {
                        label: iService.title,
                        path: iService.route,
                    },
                    { label: service.title, path: service.route },
                ]}
            />
            <ServiceDetailsCardComponent
                title={service.title}
                paras={service.paragraphs}
                coverImage={service.coverImage}
            />
            <ContactContainerComponent />;
        </>
    );
};
